<template>
  <div class="div">
    <div class="row">
      <div class="col-12">
        <div
          style="min-height: 400px;"
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <h2 style="text-align: center;" class="mb-0">{{ title }}</h2>
          <p style="text-align: center;">{{ description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // Required properties
  props: ["title", "description"]
};
</script>
